import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ItemInfo from '../../components/CoverFlow/ItemInfo';
import DriveItemUtils from '../../utils/driveItem';

const mapStateToProps = (state: StoreState, { currentDriveItem }) => {
	return {
		isEmptyContextualMenu: DriveItemUtils.isEmptyContextualMenu(currentDriveItem, state),
	};
};

export default connect(mapStateToProps)(ItemInfo);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CoverFlow/ItemInfo.tsx